module.exports = __webpack_public_path__ + "static/img/1.305e0b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/1.png
// module id = mCZs
// module chunks = 0